export default __webpack_public_path__ + "static/media/guardian_linc.c992dd7e.svg";